module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Ajouter des récompenses',
        apply: 'Appliquer',
        cancel: 'Annuler',
        applied: 'Appliqué',
        remove: 'Supprimer',
        done: 'Terminé',
        biPointsText: 'Vous êtes',
        with: 'avec',
        points: 'points.'
    };

    return resources[label];
};
